import React from "react"
import {
    Box,
    VStack,
    HStack,
    Link,
    Text,
    Image
  } from '@chakra-ui/react';

import { Link as GatsbyLink } from "gatsby"
import { EmailIcon, ExternalLinkIcon } from '@chakra-ui/icons'

import LogoImage from "../../images/index/logo.png"

const Offer: React.FC = () => {
    return (
      <Box bgColor={'gray.30'} >
      <VStack width={'full'} spacing={5} color={'black'} paddingBottom={'4rem'} position={'relative'} zIndex={'20'}>

        <Image src={LogoImage} h={16} mt={'2rem'} mb={'0.5rem'} />
        <HStack spacing={5} fontSize={'sm'}>
            <Link fontWeight={'bold'}  as={GatsbyLink} to={`/company`}>会社案内</Link>
            <Link fontWeight={'bold'}  as={GatsbyLink} to={`/recruit`}>採用情報</Link>
            <Link fontWeight={'bold'}  as={GatsbyLink} to={`/contact`}>お問い合わせ</Link>
        </HStack>
        <HStack spacing={5} fontSize={'sm'} color={'blue'} textDecoration={'underline'}>
            <Link as={GatsbyLink} to={`/privacy`}>プライバシーポリシー</Link>
            <Link as={GatsbyLink} to={`/tos`}>サイトの利用条件</Link>
        </HStack>
        <Text fontSize={'sm'} color={'gray.200'} fontWeight={'bold'}>Copyright ©️ Kowa Corporation. All Rights Reserved.</Text>
    </VStack>
    </Box>
  )
}
export default Offer